<template>
  <div class="card" :class="[marginClass, sizeClass]">
    <div v-if="showStatusBar" class="card-status-top" :class="`bg-${statusColor}`"></div>
    <div v-if="title || $slots.header || $slots.actions" class="card-header">
      <slot name="header">
        <component :is="`h${titleLevel}`" class="card-title" :class="titleClass">
          {{ title }}
        </component>
      </slot>
      <div v-if="$slots.actions" class="card-actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <div v-if="showBody" class="card-body" :class="bodyClass">
      <slot></slot>
    </div>
    <div v-if="$slots.footer" class="card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  titleLevel: {
    type: Number,
    default: 4,
    validator: (value) => value >= 1 && value <= 6
  },
  titleClass: {
    type: String,
    default: ''
  },
  showStatusBar: {
    type: Boolean,
    default: false
  },
  showBody: {
    type: Boolean,
    default: true
  },
  statusColor: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'purple', 'orange'].includes(value)
  },
  bodyClass: {
    type: String,
    default: ''
  },
  margin: {
    type: String,
    default: 'mb-3'
  },
  size: {
    type: String,
    default: '',
    validator: (value) => ['', 'sm', 'lg'].includes(value)
  }
});

const marginClass = computed(() => props.margin);
const sizeClass = computed(() => props.size ? `card-${props.size}` : '');
</script>
